import { createApi } from '@reduxjs/toolkit/query/react';
import {
  ANNOUNCEMENT_API_URL,
  NEWSLETTER_API_URL,
  TAGS_API_URL,
  CREATE_ANNOUNCEMENT_API_URL,
} from '../../utils/apiEndpoints';
import fetchQuery from '../../apiClient/fetchQuery';

export const announcementApi = createApi({
  reducerPath: 'announcementApi',
  baseQuery: fetchQuery,
  endpoints: (builder) => ({
    fetchAnnouncementsResults: builder.query({
      query: () => ({
        url: `${ANNOUNCEMENT_API_URL}`,
      }),
      transformResponse: (response) => ({
        announcements: response,
      }),
    }),
    getNewsletter: builder.query({
      query: (file_id) => ({
        url: `${NEWSLETTER_API_URL}/dialogue?file_id=${file_id}`,
      }),
      transformResponse: (response) => ({
        newsletter: response,
      }),
    }),
    fetchNewsLetterAnnouncement: builder.query({
      query: (data) => {
        let url = `announcement=${data?.id}`;
        if (data?.query) {
          url += `&query=${data?.query}`;
        }
        if (data?.tagIds && data?.tagIds.length > 0) {
          for (let i = 0; i < data?.tagIds.length; i++) {
            url += `&tags=${data?.tagIds?.[i]}`;
          }
        }
        return {
          url: `${data?.from_date && data?.to_date ? `${NEWSLETTER_API_URL}?${url}&from_date=${data?.from_date}&to_date=${data?.to_date}` : `${NEWSLETTER_API_URL}?${url}`}`,
          method: 'GET',
        };
      },
      transformResponse: (response) => ({
        announcements: response,
      }),
    }),
    createNewsletter: builder.mutation({
      query: (data) => ({
        url: `${NEWSLETTER_API_URL}`,
        method: 'PUT',
        data: data,
      }),
      transformResponse: (response) => ({
        docs: response,
      }),
    }),
    fetchTagsResults: builder.query({
      query: (query) => ({
        url: `${TAGS_API_URL}/auto-complete?q=${query}`,
      }),
      transformResponse: (response) => ({
        tags: response,
      }),
    }),
    createTags: builder.mutation({
      query: (data) => ({
        url: `${TAGS_API_URL}`,
        method: 'POST',
        data: data,
      }),
      transformResponse: (response) => ({
        tagNames: response,
      }),
    }),
    createAnnouncements: builder.mutation({
      query: (data) => ({
        url: `${CREATE_ANNOUNCEMENT_API_URL}`,
        method: 'POST',
        data: data,
      }),
      transformResponse: (response) => ({
        types: response,
      }),
    }),
  }),
});

export const {
  useFetchAnnouncementsResultsQuery,
  useCreateNewsletterMutation,
  useLazyGetNewsletterQuery,
  useLazyFetchNewsLetterAnnouncementQuery,
  useLazyFetchTagsResultsQuery,
  useCreateTagsMutation,
  useCreateAnnouncementsMutation,
} = announcementApi;
